// Constants - Functions
import { protocols } from "../../../../config/constants";
import { importImages } from "../../../../config/functions";

export const GetAppBasicProtocolData = (protocolId) => {
  const protocolImg = importImages(
    require.context("../../../../assets/images/protocols/prescriptions/app/basics", false, /\.(png|jpe?g|svg)$/)
  );

  const protocolsData = {
    [protocols.app.basic.MEMOSEQ.id]: {
      img: protocolImg["./memoseq.png"],
      name: "memoseqApp",
      video: "memoseqAppVideo",
      description: "memoseqAppDescription",
    },
    [protocols.app.basic.PLACE_IT.id]: {
      img: protocolImg["./place_it.png"],
      name: "placeIt",
      video: "placeItVideo",
      description: "placeItDescription",
    },
    [protocols.app.basic.GUESS_WHAT.id]: {
      img: protocolImg["./guess_what.png"],
      name: "guessWhat",
      video: "guessWhatVideo",
      description: "guessWhatDescription",
    },
    [protocols.app.basic.PIANOSEQ.id]: {
      img: protocolImg["./pianoseq.png"],
      name: "pianoseq",
      video: "pianoseqVideo",
      description: "pianoseqDescription",
    },
    [protocols.app.basic.BLOBS.id]: {
      img: protocolImg["./blobs.png"],
      name: "blobs",
      video: "blobsVideo",
      description: "blobsDescription",
    },
    [protocols.app.basic.SHOPPING.id]: {
      img: protocolImg["./shopping.png"],
      name: "shopping",
      video: "shoppingVideo",
      description: "shoppingDescription",
    },
    [protocols.app.basic.POPURRI.id]: {
      img: protocolImg["./potpourri.png"],
      name: "potpourri",
      video: "popurriVideo",
      description: "popurriDescription",
    },
    [protocols.app.basic.TWISTER.id]: {
      img: protocolImg["./twister.png"],
      name: "twister",
      video: "twisterVideo",
      description: "twisterDescription",
    },
    [protocols.app.basic.MEMORY.id]: {
      img: protocolImg["./memory.png"],
      name: "memory",
      video: "memoryVideo",
      description: "memoryDescription",
    },
    [protocols.app.basic.CLEANING.id]: {
      img: protocolImg["./cleaning.png"],
      name: "cleaning",
      video: "cleaningVideo",
      description: "cleaningDescription",
    },
    [protocols.app.basic.CONSTELLATIONS.id]: {
      img: protocolImg["./constellations.png"],
      name: "constellationsApp",
      video: "constellationsAppVideo",
      description: "constellationsAppDescription",
    },
    [protocols.app.basic.BALLOONS_BASIC.id]: {
      img: protocolImg["./balloons.png"],
      name: "balloonsBasic",
      video: "balloonsBasicVideo",
      description: "balloonsBasicDescription",
    },
    [protocols.app.basic.QUALITY_CONTROL_BASIC.id]: {
      img: protocolImg["./quality_control.png"],
      name: "qualityControlBasic",
      video: "qualityControlBasicVideo",
      description: "qualityControlBasicDescription",
    },
  };

  return protocolsData[Number(protocolId)];
};
